import { render } from "./Department-details.vue?vue&type=template&id=eaf590a2&scoped=true"
import script from "./Department-details.vue?vue&type=script&lang=js"
export * from "./Department-details.vue?vue&type=script&lang=js"

import "./Department-details.vue?vue&type=style&index=0&id=eaf590a2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-eaf590a2"

export default script